import React from 'react';
import { ScheduledEvent } from '../../store/types';
import { Backdrop, Card, Fade, Grid, Modal, Typography } from '@mui/material';
import WO2Button from 'src/common/components/button/Button';
import { LoadingButton } from '@mui/lab';
import { LoadingProgress } from 'src/common/store/types';

interface Props {
  isOpen: boolean;
  handleClose: () => void;
  row: ScheduledEvent;
  deleteScheduledEvent: (id: string) => void;
  deleteScheduledEventProgress: LoadingProgress;
}

export const DeleteScheduledEventModal = (props: Props) => {
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={props.isOpen}
      onClose={() => {
        props.handleClose();
      }}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Fade in={props.isOpen}>
        <Card
          elevation={0}
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            maxWidth: 400,
            padding: 2,
            width: '100%',
          }}
        >
          <Grid container direction="column" spacing={2}>
            <Grid item>
              <Typography variant="h4">Are you sure you would like to delete {props.row.name}?</Typography>
            </Grid>
            <Grid item container spacing={4}>
              <Grid item flex={1}>
                <WO2Button variant="outlined" onClick={props.handleClose}>
                  Close
                </WO2Button>
              </Grid>
              <Grid item>
                <LoadingButton
                  loading={props.deleteScheduledEventProgress.isLoading}
                  variant="contained"
                  onClick={() => {
                    props.deleteScheduledEvent(props.row.id);
                    props.handleClose();
                  }}
                >
                  Delete
                </LoadingButton>
              </Grid>
            </Grid>
          </Grid>
        </Card>
      </Fade>
    </Modal>
  );
};
